import cx from 'classnames';
import { Check, ChevronDown } from 'ethena-icons';
import PropTypes from 'prop-types';
import BootstrapForm from 'react-bootstrap/Form';
import RSAsyncSelect from 'react-select/async';
import { UtcDatePicker } from './DatePicker';
import css from './Form.module.scss';

const AsyncSelect = ({ className = '', ...rest }) => {
  const DropdownIndicator = ({ innerProps }) => (
    <div className={css.asyncSelectDropdownIcon} {...innerProps}>
      <svg
        fill="currentColor"
        height="1em"
        strokeWidth="0"
        stroke="currentColor"
        viewBox="0 0 24 24"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path>
      </svg>
    </div>
  );

  return (
    <RSAsyncSelect
      className={cx(css.asyncSelect, className)}
      classNamePrefix="as"
      components={{ DropdownIndicator }}
      {...rest}
    />
  );
};

const Checkbox = ({ className = '', disabled, label, id, ...rest }) => (
  <div
    className={cx(css.checkbox, className, {
      [css.disabled]: disabled,
    })}
  >
    <input disabled={disabled} id={id} type="checkbox" {...rest} />
    <label htmlFor={id}>
      <span className={css.checkboxCustomInput}>
        <Check color="#FFF" height={14} width={14} />
      </span>
      {label}
    </label>
  </div>
);

const Control = ({ className = '', ...rest }) => (
  <BootstrapForm.Control className={cx(className, css.control)} {...rest} />
);

const Group = ({ className = '', ...rest }) => (
  <BootstrapForm.Group className={cx(className, css.group)} {...rest} />
);

const Label = ({ className = '', children, required = false, ...rest }) => (
  <BootstrapForm.Label className={cx(className, css.label)} {...rest}>
    {children} {required && <span className={css.asterisk}>*</span>}
  </BootstrapForm.Label>
);

const Radio = ({ className = '', disabled, label, id, ...rest }) => (
  <div
    className={cx(css.radio, className, {
      [css.disabled]: disabled,
    })}
  >
    <input disabled={disabled} id={id} type="radio" {...rest} />
    <label htmlFor={id}>
      <span className={css.radioCustomInput} />
      {label}
    </label>
  </div>
);

const Select = ({
  className = '',
  width = 'full',
  wrapperClassName = '',
  ...rest
}) => (
  <div
    className={cx(css.selectWrapper, wrapperClassName, {
      [css.contentWidth]: width === 'content',
      [css.fullWidth]: width === 'full',
      'is-invalid': rest.isInvalid,
    })}
  >
    <Control as="select" className={cx(className, css.select)} {...rest} />
    <ChevronDown className={css.selectArrow} />
  </div>
);

Control.propTypes = BootstrapForm.Control.propTypes;
Group.propTypes = BootstrapForm.Group.propTypes;
Select.propTypes = BootstrapForm.Control.propTypes;

Checkbox.propTypes = Radio.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.node,
};

Label.propTypes = {
  ...BootstrapForm.Label.propTypes,
  required: PropTypes.bool,
};

Control.Feedback = BootstrapForm.Control.Feedback;

export const Form = {
  ...BootstrapForm,
  AsyncSelect,
  Checkbox,
  Control,
  Group,
  Label,
  Radio,
  Select,
  UtcDatePicker,
};
